import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Portal, useTheme } from '@mui/material';
import {
  ChevronLeft,
  ChevronRight
} from '@mui/icons-material';

const arrowSx = (side, zIndex) => ({
  display: { xs: 'none', md: 'inline-flex' },
  position: 'fixed',
  [side]: 16,
  top: '50%',
  transform: 'translateY(-50%)',
  zIndex,
  pointerEvents: 'auto',
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  color: 'grey.800',
  width: 40,
  height: 40,
  boxShadow: '0 0 8px rgba(0,0,0,0.3)',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 1)'
  },
  '& .MuiSvgIcon-root': {
    fontSize: 24
  }
});

const ArticleModalNavigationArrows = ({
  leftArrow,
  onNext,
  onPrev,
  open,
  rightArrow
}) => {
  const theme = useTheme();
  const arrowZIndex = theme.zIndex.modal + 200;

  return (
    <Portal>
      {open && leftArrow && (
        <IconButton
          aria-label="anterior"
          onClick={onPrev}
          sx={arrowSx('left', arrowZIndex)}
        >
          <ChevronLeft />
        </IconButton>
      )}
      {open && rightArrow && (
        <IconButton
          aria-label="próximo"
          onClick={onNext}
          sx={arrowSx('right', arrowZIndex)}
        >
          <ChevronRight />
        </IconButton>
      )}
    </Portal>
  );
};

ArticleModalNavigationArrows.propTypes = {
  leftArrow: PropTypes.bool,
  onNext: PropTypes.func,
  onPrev: PropTypes.func,
  open: PropTypes.bool.isRequired,
  rightArrow: PropTypes.bool
};

ArticleModalNavigationArrows.defaultProps = {
  leftArrow: false,
  onNext: undefined,
  onPrev: undefined,
  rightArrow: false
};

export default ArticleModalNavigationArrows;
